export type Integer = number & { __integerBrand: true };

export function asInteger(value: number): Integer {
  if (!Number.isInteger(value)) throw new Error("Value is not an integer");
  return value as Integer;
}
